import classNames from 'clsx'
import type { TypographyProps } from '@mui/material/Typography'

import {
  ContentSize,
  ContentSizeEnum,
  type HtmlContent as HtmlContentType,
} from '../../../../../shared/types'
import { parentMeta } from '../../type'
import styles from './HtmlContent.module.scss'
import { Typography } from '@mui/material'
import { Copy, CopyContainer } from '../../../../common/copy'
import { CopyContainerProps } from '../../../../common/copy/CopyContainer/CopyContainer'

interface HtmlContentProps {
  parentMeta?: parentMeta
  content: HtmlContentType
  size?: ContentSize
  copyContainerStyles?: CopyContainerProps
}

const tagToTypography: Record<
  string,
  {
    variant: TypographyProps['variant']
    component: keyof JSX.IntrinsicElements
    paddingLeft: '0' | 'xsmall' | 'small' | 'medium' | 'large' | 'xlarge'
    paddingRight: '0' | 'xsmall' | 'small' | 'medium' | 'large' | 'xlarge'
    paddingBottom: '0' | 'xsmall' | 'small' | 'medium' | 'large' | 'xlarge'
  }
> = {
  h1: {
    variant: 'h1',
    component: 'h1',
    paddingLeft: 'medium',
    paddingRight: 'xsmall',
    paddingBottom: 'medium',
  },
  h2: {
    variant: 'h2',
    component: 'h2',
    paddingLeft: 'large',
    paddingRight: 'xsmall',
    paddingBottom: 'xsmall',
  },
  h3: {
    variant: 'h3',
    component: 'h3',
    paddingLeft: 'large',
    paddingRight: 'xsmall',
    paddingBottom: 'xsmall',
  },
  h4: {
    variant: 'h4',
    component: 'h4',
    paddingLeft: 'large',
    paddingRight: 'xsmall',
    paddingBottom: 'xsmall',
  },
  h5: {
    variant: 'h5',
    component: 'h5',
    paddingLeft: 'large',
    paddingRight: 'xsmall',
    paddingBottom: 'xsmall',
  },
  h6: {
    variant: 'h6',
    component: 'h6',
    paddingLeft: 'large',
    paddingRight: 'xsmall',
    paddingBottom: 'xsmall',
  },
  p: {
    variant: 'body1',
    component: 'p',
    paddingLeft: 'xlarge',
    paddingRight: 'medium',
    paddingBottom: 'xsmall',
  },
  small: {
    variant: 'caption',
    component: 'small',
    paddingLeft: 'large',
    paddingRight: 'xsmall',
    paddingBottom: 'xsmall',
  },
  span: {
    variant: 'body2',
    component: 'span',
    paddingLeft: 'large',
    paddingRight: 'xsmall',
    paddingBottom: 'xsmall',
  },
  blockquote: {
    variant: 'body1',
    component: 'blockquote',
    paddingLeft: 'large',
    paddingRight: 'xsmall',
    paddingBottom: 'xsmall',
  },
}

const HtmlContent = (props: HtmlContentProps) => {
  const { content, size, copyContainerStyles } = props
  const { tag, value } = content

  const debugP2 = process.env.REACT_APP_DEBUG_P2 === 'true' ? true : false

  const typographyConfig = tagToTypography[tag] ?? tagToTypography.p

  const Tag = tag as keyof JSX.IntrinsicElements
  console.log('copyContainerStyles', copyContainerStyles)

  return (
    <div
      className={classNames(
        styles.htmlContentRoot,
        size === ContentSizeEnum.Small ? styles.small : ''
      )}
    >
      <CopyContainer
        sx={{ border: debugP2 ? 'dashed 1px #555' : '' }}
        padding={{
          left: typographyConfig.paddingLeft,
          right: typographyConfig.paddingRight,
          bottom: typographyConfig.paddingBottom,
        }}
        {...copyContainerStyles}
      >
        <Copy>
          <Typography
            variant={typographyConfig.variant}
            component={typographyConfig.component}
            color="primary"
          >
            {value}
          </Typography>
          {/* <Tag>{value}</Tag> */}
        </Copy>
      </CopyContainer>
    </div>
  )
}

export default HtmlContent
